import { Grid } from "@mui/material"
import React, { useContext } from "react"
import { LotComparaisonTable } from "./components/LotComparaisonTable"
import { ComparaisonFilter } from "./components/ComparaisonFilter"
import { ComparaisonModeSelector } from "./components/ComparaisonModeSelector"
import { ComparaisonModeContext } from "../../contexts/ComparaisonModeContext"
import { ComparaisonMode } from "../../contexts/ComparaisonMode"
import { ItemComparaisonTable } from "./components/ItemComparaisonTable"
import { BSFilterContext } from "../../../../../../../../components/charts/filters/BSFilterContext"
import { MaterialComparaisonTable } from "./components/MaterialComparaisonTable"

export function CompareVariantBottomPanel(): React.JSX.Element {
  const { allBSMaterialResult } = useContext(BSFilterContext)
  const { comparaisonMode } = useContext(ComparaisonModeContext)

  return (
    <Grid container columnSpacing={2} rowGap={3}>
      <Grid item xs={12}>
        <ComparaisonFilter allBSMaterialResult={allBSMaterialResult} />
      </Grid>
      <Grid item xs={12}>
        <ComparaisonModeSelector />
      </Grid>
      <Grid item xs={12}>
        {comparaisonMode === ComparaisonMode.LOT && <LotComparaisonTable />}
        {comparaisonMode === ComparaisonMode.ITEM && <ItemComparaisonTable />}
        {comparaisonMode === ComparaisonMode.MATERIAL && <MaterialComparaisonTable />}
      </Grid>
      <Grid item xs={12} sx={{ height: "500px" }} />
    </Grid>
  )
}
